<section class="opportunity-message-group__container flex row justify-start">
  <div class="opportunity-message-group__content" [innerHtml]="message.body | formatOpportunityMessage"></div>
</section>
